import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { noop } from 'rxjs';
import { take } from 'rxjs/operators';
import { ResourceService } from '@global/infrastructure/abstracts/resource/resource.service';
import { Environment } from '@global/infrastructure/models/environment';
import { Utility } from '@global/infrastructure/helpers/utility';
import EventEmitter from 'events';


@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler
  extends ResourceService<any>
  implements ErrorHandler
{
  constructor(httpClient: HttpClient, env: Environment) {
    super(httpClient, env, 'log');
    const globalEmitter = new EventEmitter();
    globalEmitter.setMaxListeners(20);
  }

  handleError(error: Error) {
    if (error.message !== sessionStorage.getItem('lastErrorMessage')) {
      console.error(error);
      this.create({
        appName: Utility.isMta() ? 'MTA' : 'REN',
        data: {
          name: error.name,
          message: error.message,
          stack: error.stack
        }
      })
        .pipe(take(1))
        .subscribe(noop);
      sessionStorage.setItem('lastErrorMessage', error.message);
    }
  }
}
